export default "__VITE_ASSET__v$7HXMr5__"